<template>
  <div @keydown.esc="hideModal">
    <transition name="show-modal">
      <div class="modal-wrapper" v-if="modalActive" @click.self="hideModal">
        <div class="modal">
          <div class="close-modal" @click="hideModal"></div>
          <component :is="modalComponent"></component>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: 'AppModal',
  computed: {
    modalActive() {
      return this.$store.getters.modalActive;
    },
    modalComponent() {
      const componentName = this.$store.getters.modalComponent;
      if (!componentName) return null;
      Vue.component(componentName, () => import(`./modals/${componentName}`));
      return componentName;
    }
  },
  methods: {
    hideModal() {
      this.$store.commit("hideModal");
    }
  },
  created() {
    const escapeHandler = (e) => {
      if (e.key === 'Escape' && this.modalActive) {
        this.hideModal();
      }
    };

    document.addEventListener('keydown', escapeHandler);
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler);
    });
  }
};
</script>

<style lang="scss">

.modal-wrapper {
  position: fixed;
  display: flex;
  align-items: flex-start;
  margin-left: auto;
  margin-right: auto;
  background: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  width: 100vw;
  height: 110vh;
  z-index: 10000;
}

.modal {
  background-color: #2a2a2a;
  border-radius: 10px;
  max-height: 90vh;
  position: relative;
  overflow: hidden auto;
  margin: 10vh auto;
  text-align: center;
  padding: 25px;
  min-width: 40vw;
  min-height: 40vh;

  h1 {
    margin: 15px 25px;
    font-size: 24px;
  }
}

.close-modal {
  width: 20px;
  height: 20px;
  position: absolute;
  z-index: 2;
  right: 0px;
  top: 0px;
  font-size: 25px;
  color: #707070;
  margin: 20px;
  cursor: pointer;

  &:hover:before,
  &:hover:after {
    background-color: #fff;
  }

  &:before,
  &:after {
    position: absolute;
    margin-top: 10px;
    margin-left: 1px;
    display: block;
    content: "";
    width: 18px;
    height: 2px;
    background-color: #707070;
    transition: background-color 0.25s ease;
  }

  &:before {
    transform: rotate(45deg);
  }

  &:after {
    transform: rotate(-45deg);
  }
}

</style>
